/** OnlyOffice Document Server 公网地址 */
export const OO_SERVER = process.env.VUE_APP_OO_SERVER || 'http://office.yasenkj.cn'

/** 土壤 Word 原表录入：精简 UI，单人编辑 */
export const OO_FORM_CUSTOMIZATION = {
  forcesave: true,
  compactHeader: true,
  hideRightMenu: true,
  toolbar: true,
  chat: false,
  comments: false,
  plugins: false,
  help: false,
  spellcheck: false,
  features: {
    spellcheck: { mode: false, change: false }
  }
}

export const OO_FORM_COEDITING = {
  mode: 'strict',
  change: false
}

let loadedServerBase = ''

function resolveServerBase(serverUrl) {
  const base = String(serverUrl || OO_SERVER).replace(/\/$/, '')
  if (!base) return OO_SERVER.replace(/\/$/, '')
  return base
}

function apiScriptUrl(base) {
  const url = `${base}/web-apps/apps/api/documents/api.js`
  if (process.env.NODE_ENV === 'development') {
    return `${url}?dc=${Date.now()}`
  }
  return url
}

function removeOnlyOfficeScripts() {
  document.querySelectorAll('script[data-onlyoffice="1"]').forEach(el => el.remove())
  delete window.DocsAPI
  loadedServerBase = ''
}

export function loadOnlyOfficeApi(serverUrl) {
  const base = resolveServerBase(serverUrl)
  if (window.DocsAPI && loadedServerBase === base) {
    return Promise.resolve(window.DocsAPI)
  }
  if (loadedServerBase && loadedServerBase !== base) {
    removeOnlyOfficeScripts()
  }
  return new Promise((resolve, reject) => {
    const src = apiScriptUrl(base)
    const existing = document.querySelector(`script[data-onlyoffice="1"]`)
    if (existing) {
      const existingBase = existing.dataset.serverBase || ''
      if (existingBase === base && window.DocsAPI) {
        resolve(window.DocsAPI)
        return
      }
      existing.remove()
    }
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.dataset.onlyoffice = '1'
    script.dataset.serverBase = base
    script.onload = () => {
      if (!window.DocsAPI) {
        reject(new Error(`OnlyOffice API 未就绪：${base}`))
        return
      }
      loadedServerBase = base
      resolve(window.DocsAPI)
    }
    script.onerror = () => reject(new Error(`OnlyOffice API 加载失败：${src}`))
    document.head.appendChild(script)
  })
}

/** 土壤页预加载 api.js，失败静默 */
export function preloadOnlyOfficeApi(serverUrl) {
  return loadOnlyOfficeApi(serverUrl).catch(() => {})
}

export function buildViewConfig(payload) {
  const doc = payload.document || {}
  const ed = payload.editorConfig || {}
  return {
    document: {
      fileType: doc.fileType || 'docx',
      key: doc.key || String(Date.now()),
      title: doc.title || 'form.docx',
      url: doc.url,
      permissions: doc.permissions || {}
    },
    documentType: payload.documentType || 'word',
    editorConfig: {
      mode: ed.mode || 'view',
      lang: ed.lang || 'zh-CN',
      customization: Object.assign({
        compactHeader: true,
        toolbar: false,
        hideRightMenu: true,
        hideRulers: true,
        comments: false,
        chat: false,
        help: false,
        plugins: false,
        spellcheck: false,
        features: {
          spellcheck: { mode: false, change: false }
        }
      }, ed.customization || {})
    },
    width: '100%',
    height: '100%'
  }
}

/** 编辑模式（Word 原表录入） */
export function buildEditConfig(payload, events = {}) {
  const doc = payload.document || {}
  const ed = payload.editorConfig || {}
  return {
    document: {
      fileType: doc.fileType || 'docx',
      key: doc.key || String(Date.now()),
      title: doc.title || 'form.docx',
      url: doc.url,
      permissions: Object.assign({ edit: true, download: true, print: true }, doc.permissions || {})
    },
    documentType: payload.documentType || 'word',
    editorConfig: {
      mode: ed.mode || 'edit',
      lang: ed.lang || 'zh-CN',
      callbackUrl: ed.callbackUrl,
      user: ed.user || { id: '0', name: '用户' },
      coEditing: Object.assign({}, OO_FORM_COEDITING, ed.coEditing || {}),
      customization: Object.assign({}, OO_FORM_CUSTOMIZATION, ed.customization || {})
    },
    events,
    width: '100%',
    height: '100%'
  }
}
